import { Box, Card, Badge, Button, Tooltip } from '@mui/material';

import { Iconify } from '../iconify';
import { QuickFilters } from './QuickFilters';

import type { QuickFiltersProps } from './QuickFilters';

type FiltersToolbarProps = {
  onOpen: VoidFunction;
  onExport?: VoidFunction;
  onReloadData?: VoidFunction;
  hideQuickFilters?: boolean;
  loading?: boolean;
  slots: {
    quickFilters: QuickFiltersProps;
  };
};

export function FiltersToolbar({
  onOpen,
  onExport,
  onReloadData,
  loading,
  slots,
  hideQuickFilters = false,
}: FiltersToolbarProps) {
  return (
    <Card
      sx={{
        p: 2.5,
        pr: 2,
      }}
    >
      <Box
        sx={{
          gap: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { md: 'center' },
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {!hideQuickFilters && <QuickFilters {...slots.quickFilters} />}
        <Box sx={{ gap: 1, flexShrink: 0, display: 'flex' }}>
          <Button
            disableRipple
            color="inherit"
            variant="contained"
            startIcon={
              <Badge color="error" variant="dot">
                <Iconify icon="ic:round-filter-list" />
              </Badge>
            }
            onClick={onOpen}
          >
            Filters
          </Button>
          {onExport && (
            <Tooltip title="Exported data will represent the current filters applied.">
              <Button
                startIcon={<Iconify icon="ic:round-file-download" />}
                disabled={loading}
                size="medium"
                variant="outlined"
                onClick={onExport}
                color="inherit"
              >
                Export
              </Button>
            </Tooltip>
          )}
          {onReloadData && (
            <Tooltip title="Reload data">
              <Button
                variant="outlined"
                sx={{ width: 36, padding: 0, minWidth: 36 }}
                color="inherit"
                onClick={onReloadData}
                disabled={loading}
              >
                <Iconify icon="ic:round-refresh" />
              </Button>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Card>
  );
}
